import React from "react"
import { FlyOutPanel } from "@4cplatform/elements/Molecules"

// Components
import ProviderView from "./providers.panel.view"

const ProvidersPanel = () => <FlyOutPanel body={() => <ProviderView />} name="providers_panel" />

export default ProvidersPanel
